import {fr} from './fr';
import {en} from './en';

export const messages = {
    'fr': fr,
    'en': en
};
